import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import DefaultModal from '../../../components/Modals/DefaultModal';
import SuccessModal from '../../../components/Modals/SuccessModal';
import { invoiceService } from '../../../services/invoiceService';

interface Props {
  openModal: boolean;
  closeModal: () => void;
  invoiceIds: number[];
  onSuccess: () => void;
}

const ApproveInvoiceModal = (props: Props): JSX.Element => {
  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [initials, setInitials] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const confirmHandler = () => {
    if (initials) {
      invoiceService
        .approveInvoice({ initials, invoiceIds: props.invoiceIds })
        .then(() => {
          setConfirmDialog(true);
        });
      handleClose();
    } else {
      setError(true);
    }
  };

  const handleClose = () => {
    setError(false);
    props.closeModal();
  };

  const handleSuccess = () => {
    props.onSuccess();
    setConfirmDialog(false);
  };

  return (
    <>
      <DefaultModal open={props.openModal} handleClose={handleClose}>
        <Box sx={{ px: 6 }}>
          <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
            {props.invoiceIds.length > 1
              ? ' Approve Invoices'
              : ' Approve Invoice'}
          </Typography>
          <Typography textAlign="center">
            Please enter your initials to approve
            <strong>
              {props.invoiceIds.length > 1 ? ' selected Invoices' : ' Invoice'}
            </strong>
          </Typography>
          <TextField
            sx={{ width: '100%', my: 3 }}
            label="Your initials"
            name="initials"
            error={error}
            value={initials}
            onChange={(event) => setInitials(event.target.value)}
          />
        </Box>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button onClick={confirmHandler} sx={{ width: '200px' }}>
            Confirm
          </Button>
        </DialogActions>
      </DefaultModal>
      <SuccessModal open={confirmDialog} handleClose={handleSuccess}>
        <Typography textAlign="center">
          {props.invoiceIds.length > 1 ? 'Invoices have ' : 'Invoice has '}
          been approved.
        </Typography>
      </SuccessModal>
    </>
  );
};

export default ApproveInvoiceModal;
